import { FC, useEffect, useState } from "react";
import Box from "@mui/material/Box";

type Props = {
    url?: string;
    type?: string;
};

const MediaPlayer: FC<Props> = ({ url, type }) => {
    const [mediaUrl, setMediaUrl] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (url) {
            const fetchMedia = async () => {
                try {
                    const response = await fetch(url, {
                        headers: {
                            Range: "bytes=0-"
                        }
                    });
                    const blob = await response.blob();
                    const objectUrl = URL.createObjectURL(blob);
                    setMediaUrl(objectUrl);
                } catch (error) {
                    console.error("Error fetching media:", error);
                }
            };

            fetchMedia();
        }
    }, [url]);

    if (!mediaUrl) {
        return null;
    }

    return (
        <Box sx={{ mt: 3 }}>
            {type === "audio" ? (
                <Box component="audio" sx={{ maxWidth: 1, width: 450 }} controlsList="nodownload" controls>
                    <source src={mediaUrl} />
                </Box>
            ) : (
                <Box component="video" sx={{ maxWidth: 1, borderRadius: 1 }} controlsList="nodownload" controls autoPlay={false}>
                    <source src={mediaUrl} type="video/mp4" />
                    <source src={mediaUrl} type="video/ogg" />
                </Box>
            )}
        </Box>
    );
};

export default MediaPlayer;